// Libs
import { connect } from 'react-redux'

// Component
import HeftyGrid from '../components/HeftyGrid'

// Selectors
import gridBboxOfSelectedField$ from 'hfty-map/src/selectors/gridBboxOfSelectedField'
import { operations$, operation$ } from 'hfty-soil-jobs-dom'
import { selectedFeatureIndices$ } from 'hfty-map'

// Operators
import soilJobsOperator from 'fc-operator-sampling-jobs'

const mapDispatchToProps = {
  onChangeGridOffset: soilJobsOperator.actionCreators.updateOperation,
}

const mapStateToProps = (state: Object, props: Object) => ({
  operation: operation$(state),
  selectedField: gridBboxOfSelectedField$(state),
  operations: operations$(state),
  gridData: props.gridData,
  selectedFeatureIndices: selectedFeatureIndices$(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(HeftyGrid)
